export default defineNuxtRouteMiddleware((_to, _from) => {
  if (import.meta.server) { return }
  if (import.meta.client) {
    const { kakaoPixelPageView } = useKakaoPixel()
    kakaoPixelPageView('')
  }
})
